var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ta-total-items-found"},[_vm._v(" "+_vm._s(_vm.auctions.totalRows == 1 ? _vm.$t('{total} item found', {total: _vm.auctions.totalRows}) : _vm.$t('{total} items found', {total: _vm.auctions.totalRows}))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }